import { Position, Range } from 'types'
import { MediaSprite } from '../../../types'
import Renderer from '../classes/renderer'

export async function createSprite(
    frames: number,
    fps: number,
    trim?: Range,
    renderer?: Renderer | null,
    crop?: Position
): Promise<MediaSprite | null> {
    if (!renderer) {
        return null
    }

    const maxFrame = Math.floor((trim?.end || 1) * frames)
    const minFrame = Math.floor((trim?.start || 0) * frames)
    const totalFrames = maxFrame - minFrame
    const duration = totalFrames / fps
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    const columns = Math.round(Math.sqrt(totalFrames))
    const rows = Math.ceil(totalFrames / columns)
    const frameIndexes: number[] = []
    const frameWidth = crop?.width || renderer.gl.canvas.width
    const frameHeight = crop?.height || renderer.gl.canvas.height

    canvas.width = Math.round(frameWidth * columns)
    canvas.height = Math.round(frameHeight * rows)

    for (let i = 0; i < totalFrames; i++) {
        const x = (i % columns) * frameWidth
        const y = Math.floor(i / columns) * frameHeight
        const frame = i + minFrame

        renderer.render(frame / frames)

        context?.drawImage(
            renderer.gl.canvas,
            crop?.x || 0,
            crop?.y || 0,
            frameWidth,
            frameHeight,
            x,
            y,
            frameWidth,
            frameHeight
        )

        frameIndexes.push(i)

        await new Promise((resolve) => {
            setTimeout(resolve, 0)
        })
    }

    return {
        canvas,
        columns,
        duration,
        frameHeight,
        frameIndexes,
        frameWidth,
        numFrames: totalFrames,
        rows,
    }
}
